import { Flex } from "@gravity-ui/uikit";

import { BlurPrice } from "../../../../PriceProps";
import { ActiveVariantTreeDto } from "../../../../VariantTreeDto";
import { ProductInfoCard } from "./components";
import { useProductInfoTranslate } from "./components/hooks";
import css from "./ProductInfo.module.scss";

interface ProductInfoProps {
  isLoading: boolean;
  blurPrice: BlurPrice | null;
  isBlur: boolean;
  showSelectPlatformPrompt: boolean;
  activeVariant: ActiveVariantTreeDto | null;
  isDesktop: boolean;
}
export const ProductInfo = ({
  isLoading,
  isBlur,
  blurPrice,
  showSelectPlatformPrompt,
  activeVariant,
  isDesktop,
}: ProductInfoProps) => {
  const translations = useProductInfoTranslate();

  if (!activeVariant)
    return (
      <ProductInfoCard
        key={0}
        price={blurPrice?.price}
        currency={blurPrice?.currency}
        deliveryBlur={blurPrice?.delivery}
        isLoading={isLoading}
        isBlur={isBlur}
        promptText={
          showSelectPlatformPrompt
            ? translations.select_platform_hint
            : undefined
        }
      />
    );

  return (
    <Flex
      direction={isDesktop ? "row" : "column"}
      width="100%"
      gap="3"
      wrap
      className={css.priceInfo}
    >
      {activeVariant.prices.map((value, idx) => (
        <ProductInfoCard
          key={idx}
          price={value.price}
          currency={value.currency}
          delivery={value.delivery}
          store={value.store}
          supplierName={value.supplierName}
          url={value.url}
          isLoading={isLoading}
          isBlur={isBlur}
        />
      ))}
    </Flex>
  );
};
